<template>
  <a-modal
    :title="title"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-item
        v-show="false"
        label="id"
        :hidden="true"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['id']"
          :disabled="showable"
        />
      </a-form-item>
      <a-form :form="form">
        <a-form-item
          label="主键"
          :hidden="true"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            v-decorator="['id', {rules: [{required: false, message: '请输入id'}]}]" />
        </a-form-item>
        <a-form-item
          label="姓名"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入姓名"
            v-decorator="['name', {rules: [{required: true, message: '请输入姓名'}]}]" />
        </a-form-item>
        <a-form-item
          label="性别"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >

          <a-radio-group
            :disabled="showable"
            v-decorator="['sex', {rules: [{required: true, message: '请选择性别'}]}]"
          >
            <a-radio value="1">男</a-radio>
            <a-radio value="0">女</a-radio>
          </a-radio-group>

        </a-form-item>
        <a-form-item
          label="身份证号"
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入身份证号码"
            v-decorator="['idNumber', {
              rules: [{required: true, message: '请输入身份证号码'},
                      {pattern:new RegExp(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/),
                       message:'请输入正确的身份证号'}
              ]}]" />
        </a-form-item>
        <!--        工人类别id，关联工人类别表-->
        <a-form-item
          :hidden="linkable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          icon="question-circle-o"
        >
          <span slot="label">
            工人类别&nbsp;
            <a-tooltip title="工人类别是由管理员添加,如有疑问请联系管理员在系统管理/工人类别下进行相关操作">
              <a-icon type="question-circle-o" style="color: blue"/>
            </a-tooltip>
          </span>
          <a-select
            placeholder="请选择工人类别"
            showSearch
            :filterOption="filterOption"
            :disabled="showable"
            :options="workerList"
            v-decorator="['typeId', {rules: [{required: true, message: '请选择工人类别'}]}]" />
        </a-form-item>
        <!--        <a-form-item-->
        <!--          label="排序"-->
        <!--          :hidden="linkable"-->
        <!--          :labelCol="labelCol"-->
        <!--          :wrapperCol="wrapperCol"-->
        <!--        >-->
        <!--          <a-input-number-->
        <!--            :disabled="showable"-->
        <!--            :min="1"-->
        <!--            placeholder="请输入"-->
        <!--            v-decorator="['sort', {rules: [{required: true, message: '请输入'}]}]" />-->
        <!--        </a-form-item>-->
        <!--        考勤小组id，关联考勤小组表-->
        <a-form-item
          :hidden="addable||editable||showable"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <span slot="label">
            考勤小组&nbsp;
            <a-tooltip title="考勤小组是由管理员添加,如有疑问请联系管理员在系统管理/项目/公司考勤小组增减下进行相关操作">
              <a-icon type="question-circle-o" style="color: blue"/>
            </a-tooltip>
          </span>
          <a-select
            showSearch
            :disabled="showable"
            :options="teamList"
            :filterOption="filterOption"
            placeholder="请选择考勤小组"
            v-decorator="['groupId', {rules: [{required: false, message: '请选择考勤小组'}]}]" >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer" >
      <div v-show="editable || addable || linkable">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { FormMixin } from '@/mixins/FormMixin'
import { getObj, addObj, putObj, attendTeamList, addAttendGroup, removeAttendGroupLink } from '@/api/common/AttendWorker'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
export default {
  name: 'AttendWorkerAddOrUpdate',
  mixins: [FormMixin],
  data () {
    return {
      confirmLoading: false,
      form: this.$form.createForm(this),
      workerList: [],
      teamList: [],
      value: 1,
      showable: false
    }
  },
  methods: {
    edit (id, type) {
      this.list = []
      this.visible = true
      attendTeamList().then(res => {
        this.teamList = res.data
      })
      dropSxWorkerTypeList().then(res => {
        this.workerList = res.data
      })
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show', 'link', 'removeLink'].includes(type)) {
        this.confirmLoading = true
        getObj(id).then(res => {
          const record = res.data
          this.confirmLoading = false
          this.$nextTick(() => {
            setFieldsValue(pick(record, ['id', 'name', 'sex', 'sort', 'idNumber', 'typeId', 'groupId']))
          })
        })
      } else {
        resetFields()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleOk () {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          try {
            if (this.type === 'add') {
              await addObj(values)
            } else if (this.type === 'edit') {
              await putObj(values)
            } else if (this.type === 'link') {
              values.workId = values.id
              values.id = null
              await addAttendGroup(values)
            } else if (this.type === 'removeLink') {
              values.workId = values.id
              values.id = null
              await removeAttendGroupLink(values)
            }
            setTimeout(() => {
              this.confirmLoading = false
              this.$emit('ok')
              this.handleCancel()
            }, 1500)
          } catch (e) {
            this.confirmLoading = false
            this.$message.error(e.msg)
          }
        }
      })
    },
    onRadioSex (e) {
      console.log('radio checked', e.target.value)
    }
  }
  // filterOption (input, option) {
  //   return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  // }
}
</script>

<style scoped>

</style>
